<div
  #footer
  class="fixed right-0 bottom-0 left-0 h-22 border-t-4 border-grey-50 bg-white pb-sm md:pb-0"
  *transloco="let t"
>
  <div class="flex" style="margin-top: -4px">
    @for (item of steps$ | async; track $index) {
      <div class="border-t-4 border-gold-500" [style.width.px]="stepWidthInPx"></div>
    }
  </div>
  <div class="h-layout flex h-full items-center justify-between">
    @if (!showPoweredByBuildigo) {
      <button type="button" class="btn btn-ghost" (click)="cancelButtonClick.emit()">
        {{ t('createJobRequest.cancel') }}
      </button>
    }
    @if (showPoweredByBuildigo) {
      <div
        class="inline-flex h-[24px] cursor-pointer items-center justify-center space-x-2xs rounded-1 border border-grey-300 bg-grey-50 px-xs py-2xs text-xs hover:border-grey-500"
        [routerLink]="linkService.homePath"
        bgoOpenNewTab
      >
        <div class="whitespace-nowrap text-president-500">{{ t('createJobRequest.navbar.poweredBy') }}</div>
        <a [routerLink]="linkService.homePath" class="mt-2xs" bgoOpenNewTab>
          <img
            ngSrc="assets/images/buildigo.svg"
            width="55"
            height="13"
            class="h-[10px] object-cover sm:h-[13px]"
            alt="Powered by Buildigo"
          />
        </a>
      </div>
    }
    <div class="space-x-sm">
      @if (showBackButton) {
        <button type="button" class="btn space-x-xs btn-secondary" (click)="backButtonClick.emit()">
          <fa-icon [icon]="backIcon"></fa-icon>
          <span class="hidden md:inline">
            {{ t('createJobRequest.previous') }}
          </span>
        </button>
      }
      <button
        type="submit"
        class="btn btn-primary bg-vermillon-500"
        (click)="nextButtonClick.emit()"
        cft-button
        [isLoading$]="nextButtonLoading$"
      >
        {{ nextButtonText || t('createJobRequest.next') }}
      </button>
    </div>
  </div>
</div>
